import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useForecast } from '../context/useForecast';
import { AppShell } from '../components/layout/AppShell';
import { Skeleton } from '../components/ui/skeleton';

function LoadingScreen() {
  return (
    <div className="flex h-screen bg-background">
      {/* Sidebar skeleton — calquée sur la vraie sidebar (fond forêt #002108) */}
      <div className="w-56 bg-[#002108] p-4 space-y-3">
        <div className="h-10 w-full rounded-lg bg-white/5 animate-pulse" />
        <div className="space-y-1 pt-2">
          {Array.from({ length: 8 }).map((_, i) => (
            <div key={i} className="h-9 w-full rounded-md bg-white/5 animate-pulse" />
          ))}
        </div>
      </div>
      <main className="flex-1 p-6 space-y-4">
        <div className="flex items-center justify-between">
          <Skeleton className="h-8 w-56" />
          <Skeleton className="h-9 w-32 rounded-md" />
        </div>
        <div className="grid grid-cols-4 gap-4">
          {Array.from({ length: 8 }).map((_, i) => (
            <Skeleton key={i} className="h-24 rounded-lg" />
          ))}
        </div>
        <div className="grid grid-cols-2 gap-4">
          <Skeleton className="h-64 rounded-lg" />
          <Skeleton className="h-64 rounded-lg" />
        </div>
      </main>
    </div>
  );
}

export function AppPage() {
  const { session, loading: authLoading, mustSetPassword, passwordRecovery } = useAuth();
  const { loading: forecastLoading } = useForecast();

  if (authLoading) return <LoadingScreen />;
  if (!session) return <Navigate to="/login" replace />;

  // Un invité doit définir son mot de passe avant d'accéder à l'application.
  // Idem pour une session de récupération (lien "mot de passe oublié").
  if (mustSetPassword || passwordRecovery) {
    return <Navigate to="/set-password" replace />;
  }

  if (forecastLoading) return <LoadingScreen />;

  return <AppShell />;
}
